// extracted by mini-css-extract-plugin
export default {"container":"Notifications_container__pSWYq","wrapper":"Notifications_wrapper__TYLJG","card":"Notifications_card__mfcnh","emptyCard":"Notifications_emptyCard__IJhfi"};